"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_COMPARE_MIN_N = exports.CHART_COMPARE_DOUBLE_MAX_SCHOOLS = exports.CHART_COMPARE_MAX_GROUPS = exports.CHART_COMPARE_LABEL_DE = exports.CHART_COMPARE_COLORS = exports.CHART_COMPARE_GROUPS = exports.CHART_COMPARE_BY = void 0;
exports.chartCompareCombos = chartCompareCombos;
exports.compareAllHidden = compareAllHidden;
exports.mapCompareAllHidden = mapCompareAllHidden;
const chart_colors_1 = require("./chart-colors");
const weight_class_1 = require("./weight-class");
exports.CHART_COMPARE_BY = [
    "gender",
    "sportsClub",
    "weightClass",
];
/** Subgroups in display order (left bar first). */
exports.CHART_COMPARE_GROUPS = {
    gender: ["MALE", "FEMALE"],
    sportsClub: ["YES", "NO"],
    // Weight class at the respective test; "keine Angabe" is in no subgroup.
    weightClass: weight_class_1.WEIGHT_CLASS_KEYS,
};
/**
 * Gerald: Buben blue, Mädchen pink, Sportverein ja green, nein red; the
 * weight classes keep the colours of the Gewichtsklassifikation.
 */
exports.CHART_COMPARE_COLORS = {
    MALE: "#2F6DB5",
    FEMALE: "#E0559A",
    YES: "#2E8B57",
    NO: "#C8322B",
    ...chart_colors_1.CHART_WEIGHT_CLASS_COLORS,
};
exports.CHART_COMPARE_LABEL_DE = {
    MALE: "Buben",
    FEMALE: "Mädchen",
    YES: "Sportverein ja",
    NO: "Sportverein nein",
    ...weight_class_1.WEIGHT_CLASS_LABEL_DE,
};
/**
 * Double comparison: at most this many subgroups (5 weight classes x 2) and
 * schools (1-4: panels; the compact 5-20 table has no room for it).
 */
exports.CHART_COMPARE_MAX_GROUPS = 10;
exports.CHART_COMPARE_DOUBLE_MAX_SCHOOLS = 4;
/** Subgroups of a (double) comparison: key2 outer, key inner. */
function chartCompareCombos(by, by2) {
    const inner = exports.CHART_COMPARE_GROUPS[by];
    if (!by2)
        return inner.map((key) => ({ key }));
    return exports.CHART_COMPARE_GROUPS[by2].flatMap((key2) => inner.map((key) => ({ key, key2 })));
}
/**
 * Super admin views: a subgroup cell (timepoint, or one feature mean) with
 * fewer children is sent without numbers ("n < 5"). Enforced in the backend.
 */
exports.CHART_COMPARE_MIN_N = 5;
/**
 * The privacy rules hid EVERY value of a comparison (e.g. the 3 x 3
 * all-or-nothing rule of Geschlecht x Sportverein in a small school): no
 * shown value, at least one hidden cell. Fitnesswerte: at `timepoint`;
 * Gewichtsklassifikation: over all timepoints. The views then show the note
 * "Zu wenige Kinder für diese Gegenüberstellung" instead of an empty plot.
 */
function compareAllHidden(compare, mode, timepoint) {
    const cells = compare.groups.flatMap((g) => g.timepoints.filter((tp) => mode === "weight" || tp.key === timepoint));
    if (mode === "weight") {
        return (!cells.some((c) => c.weight !== null) &&
            cells.some((c) => c.suppressed || (c.n ?? 0) > 0));
    }
    const shown = cells.some((c) => !c.suppressed && Object.values(c.means).some((v) => v !== null));
    const hidden = cells.some((c) => c.suppressed || Object.values(c.meanN).some((n) => n === null));
    return !shown && hidden;
}
/**
 * Map / drill-down "Gegenüberstellen": every subgroup of every region (or
 * school point) with data is hidden, nothing is shown. `schools` = 0 marks a
 * region without schools (not hidden, just empty).
 */
function mapCompareAllHidden(cells) {
    const shown = cells.some((c) => !c.suppressed && c.value !== null);
    const hidden = cells.some((c) => c.suppressed && (c.schools === undefined || c.schools > 0));
    return !shown && hidden;
}
